import React from 'react';
import {IOrderModel} from '../../../../../src/@interfaces/models/Order/IOrderModel';
import {BootstrapColors} from '../../../../../src/@types/Bootstrap';
import {OrderAttentionPossibleTypes} from '../../../../../src/@interfaces/models/Order/IOrderAttentionModel';
import OrderDeletionRequest from './OrderDeletionRequest';
import OrderStatusExpired from './OrderStatusExpired';
import ControlledOrderAttentionMessage from './ControlledOrderAttentionMessage';
import OrderProductDeadlineExpired from './OrderProductDeadlineExpired';

export type AttentionMessageProps = {
    model: NonNullable<IOrderModel['attentions']>[number],
    setMessages: React.Dispatch<React.SetStateAction<{ color: BootstrapColors, message: string }[]>>,
    catchHttpException: (e: Error) => any,
};

const map: Record<OrderAttentionPossibleTypes, React.ComponentType<AttentionMessageProps>> = {
    'order-deletion-request': OrderDeletionRequest,
    'order-status-expired': OrderStatusExpired,
    'order-product-deadline-expired': OrderProductDeadlineExpired
};

export function renderOrderAttentionRepresentation(model: AttentionMessageProps['model']) {
    const type = model.type as keyof typeof map;
    const Component = map[type] ?? null;
    if (!Component) {
        return null;
    }

    return <ControlledOrderAttentionMessage
            message={`OrderAttentionsField.messages.${type}`}
            component={Component}
            model={model}
    />;
}
